var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.428,
    height: 36.055,
    viewBox: "0 0 40.428 36.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "f0wxge0qpa",
    x: 10.883,
    y: 0,
    width: 29.545,
    height: 36.055,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rjrit8ygeb",
    x: 0,
    y: 4.789,
    width: 33.758,
    height: 26.443,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8099"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8093"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8095"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#f0wxge0qpa)"
    },
    transform: "translate(-.003 .004)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1081",
    d: "m14887.156-21398.16 10.232 7.449-10.232 8.553v-2.43l7.316-6.123-7.316-5.506z",
    transform: "translate(-14866.77 21405.14)",
    style: {
      fill: "#9079a8",
      stroke: "#9079a8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#rjrit8ygeb)"
    },
    transform: "translate(-.003 .004)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1082",
    d: "m14891-21396.867 4.7 3.1-4.7 3.426v-1.223l-8.219-2 8.219-2.328z",
    transform: "translate(-14871.81 21408.59)",
    style: {
      fill: "#f9bd77",
      stroke: "#fbbe77"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/SelectedIcon.adf85d9913a2327d4645a47bbc0920b7.svg";
export { ForwardRef as ReactComponent };